<template>
	<!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-产品-添加
    -->
	<el-dialog title="添加产品" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
		:close-on-press-escape="false" width="90%">
		<div class="product-add pb50">
			<el-form size="small" :model="form" ref="form" :rules="{...rules}" label-width="100px">
				<el-form-item label="产品名称" prop="name"><el-input v-model="form.name" placeholder="请输入产品名称"
						class="max-w460"></el-input></el-form-item>


				<el-form-item label="所属分类：" prop="model.category_id">
					<el-select v-model="form.category_id">
						<template v-for="cat in catgory">
							<el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
							<template v-if="cat.child !== undefined" v-for="two in cat.child">
								<el-option :value="two.category_id" :key="two.category_id" :label="two.name"
									style="padding-left: 30px"></el-option>
								<template v-if="two.child !== undefined" v-for="three in two.child">
									<el-option :value="three.category_id" :key="three.category_id" :label="three.name"
										style="padding-left: 60px"></el-option>
								</template>
							</template>
						</template>
					</el-select>
				</el-form-item>

				<el-form-item label="上传讲解视频：" prop="video_url">
					<div class="draggable-list">
						<div v-if="form.video_url">
							<div class="item">

								<video :src="form.video_url" style="width:100%;height:100%;object-fit:contain;"
									preload="metadata" controls>
								</video>

								<a href="javascript:void(0);" class="delete-btn" @click.stop="form.video_url = ''">
									<i class="el-icon-close"></i>
								</a>
							</div>
						</div>
						<div class="item img-select" @click="openProductUpload('videourl')">
							<i class="el-icon-plus"></i>
						</div>
					</div>
				</el-form-item>

				<el-form-item label="产品图片：" prop="model.image">
					<div class="draggable-list">

						<div>
							<div class="item">
								<img v-img-url="form.image" alt="file_path" />
								<a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'album')"><i
										class="el-icon-close"></i></a>

							</div>
						</div>

						<div class="item img-select" @click="openProductUpload('album')">
							<i class="el-icon-plus"></i>
						</div>
					</div>
				</el-form-item>

				<el-form-item label="产品bannar：" prop="model.image">
					<div class="draggable-list">
						<draggable class="wrapper" v-model="form.bannar">
							<transition-group>
								<div v-for="(item, index) in form.bannar" :key="item.file_path">
									<div class="item">
										<img v-img-url="item.file_path" alt="file_path" />
										<a href="javascript:void(0);" class="delete-btn"
											@click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
									</div>
								</div>
							</transition-group>
						</draggable>
						<div class="item img-select" @click="openProductUpload('bannar')">
							<i class="el-icon-plus"></i>
						</div>
					</div>
				</el-form-item>


				<el-form-item label="产品价格" prop="price">
					<el-input v-model="form.price" type="number" placeholder="请输入产品价格"
						class="max-w460"></el-input></el-form-item>


				<el-form-item label="产品介绍" prop="tip">
					<el-input v-model="form.tip" type="textarea" placeholder="请输入产品介绍" class="max-w460"></el-input>
				</el-form-item>

				<el-form-item label="虚拟浏览量" prop="fview">
					<el-input v-model="form.fview" type="number" placeholder="请输入虚拟浏览量"
						class="max-w460"></el-input></el-form-item>
				<!-- 2024年12月新增 -->
				<el-form-item label="产品类型" prop="is_standard">
					<el-radio-group v-model="form.is_standard">
						<el-radio :label="0">标品</el-radio>
						<el-radio :label="1">基础定制</el-radio>
						<el-radio :label="2">面积定制</el-radio>
						<el-radio :label="3">周长定制</el-radio>
					</el-radio-group>
				</el-form-item>

				 <el-form-item 
    label="勾选后标品将不显示前端上传文件组件，不勾选默认显示" 
    v-if="form.is_standard === 0"
    prop="standard_files"
  >
  <div class="upload-toggle" style="margin-top: 40px;">
        <el-switch
          v-model="form.showStandardUpload"
          active-text="隐藏上传"
          inactive-text="显示上传"
          :active-value="1"
             :inactive-value="0"
        ></el-switch>
      </div>


  </el-form-item>



				<!-- 选择标签 -->
				<!-- 选择标签 -->
				<el-form-item label="选择子类型">
					<el-select id="searchType" @change="typeChange" class="searchType">
						<el-option v-for="(item,index) in type" :key="index" :label="item.name"
							:value="item"></el-option>

					</el-select>
				</el-form-item>


				<el-form-item label="类型">

					<el-table :data="form.hproducttosubcategories" border size="mini"
						style="width: 100%;margin-top: 20px;">

						<el-table-column prop="name" label="排序">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input style="width: 150px;" v-model="scope.row.sort"
										placeholder="请输入排序"></el-input>
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="是否自定义价格" width="120" v-if='form.is_standard==0'>
							<template v-slot="scope">
								<el-switch v-model="scope.row.is_custom_label" :active-value="1" :inactive-value="0"
									active-text="是" inactive-text="否"></el-switch>
							</template>
						</el-table-column>



						<el-table-column prop="name" label="类型" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									{{ scope.row.name }}
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="价格" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input v-model="scope.row.price"></el-input>

								</div>
							</template>
						</el-table-column>


						<el-table-column prop="name" label="操作" width="100">
							<template v-slot="scope">
								<div style="color: blue;" @click="delType(scope.$index)">删除</div>

							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item label="邮费选择" prop="postage_id">
					<div>当前选中：{{ selectedPostageNames }}</div>
					<el-checkbox-group v-model="form.postages">
						<el-checkbox v-for="item in postage" :key="item.postage_id" :label="String(item.postage_id)">
							{{ item.name }}（{{ item.price }}元）
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<!-- 参数选择 -->
				<el-form-item label="选择参数">
					<el-button type="primary" size="small" @click="openParamDialog">选择参数</el-button>
				</el-form-item>

				<!-- 参数弹窗 -->
				<div class="param-selector-overlay" v-if="paramOverlayVisible"
					@click.self="paramOverlayVisible = false">
					<div class="param-selector-container">
						<div class="param-selector-header">
							<h3>选择参数</h3>
							<el-button icon="el-icon-close" circle @click="paramOverlayVisible = false"></el-button>
						</div>

						<div class="param-selector-body">
							<div style="display: flex; height: 500px;">
								<!-- 左侧分类菜单 -->
								<div
									style="width: 200px; border-right: 1px solid #eee; padding-right: 10px; overflow-y: auto;">
									<el-checkbox-group v-model="selectedCategories" @change="handleCategoryChange">
										<div v-for="parent in parameterList" :key="'cat-'+parent.category_id"
											style="padding: 8px 0; border-bottom: 1px solid #f0f0f0;">
											<el-checkbox :label="String(parent.category_id)" style="width: 100%;">
												{{ parent.name }}
												<span v-if="parent.child && parent.child.length > 0"
													style="margin-left: 5px; color: #999;">
													({{ parent.child.length }})
												</span>
											</el-checkbox>
										</div>
									</el-checkbox-group>
								</div>

								<!-- 右侧参数表格 -->
								<div style="flex: 1; padding-left: 20px; overflow-y: auto;">
									<div v-if="filteredParams.length === 0"
										style="text-align: center; margin-top: 100px; color: #999;">
										<i class="el-icon-warning" style="font-size: 24px;"></i>
										<p>请先选择左侧的分类</p>
									</div>

									<el-table v-else :data="filteredParams" border
										@selection-change="handleSelectionChange" style="width: 100%" height="100%">
										<el-table-column type="selection" width="55"></el-table-column>
										<el-table-column prop="category_name" label="所属分类"
											width="120"></el-table-column>
										<el-table-column prop="name" label="参数名称" width="180"></el-table-column>
										<el-table-column label="排序" width="120">
											<template v-slot="scope">
												<el-input-number v-model="scope.row.tempSort" :min="0" :controls="false"
													size="small" style="width: 100%"></el-input-number>
											</template>
										</el-table-column>



									</el-table>
								</div>
							</div>
						</div>

						<div class="param-selector-footer">
							<el-button @click="paramOverlayVisible = false">取消</el-button>
							<el-button type="primary" @click="saveSelectedParams"
								:disabled="selectedParams.length === 0">
								确定 (已选 {{ selectedParams.length }} 个)
							</el-button>
						</div>
					</div>
				</div>

				<el-form-item>

					<!-- 分类横向滚动单选区域 -->
					<div class="category-scroll-container">
						<el-scrollbar style="height: 60px;" wrap-class="scrollbar-wrapper">
							<div class="category-tabs">
								<el-radio-group v-model="activeCategory" @change="handleCategoryChangex">
									<el-radio-button v-for="category in categories" :key="category.value"
										:label="category.value">
										{{ category.label }}
									</el-radio-button>
								</el-radio-group>
							</div>
						</el-scrollbar>
					</div>

					<el-table :data="filteredProducts" border size="mini" style="width: 100%;margin-top: 20px;"
						v-if="filteredProducts.length > 0">

						<el-table-column prop="name" label="排序" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input style="width: 80px;" v-model="scope.row.sort"
										placeholder="请输入排序"></el-input>
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="名称" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									{{ scope.row.name }}
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="category_name" label="类别" width="90">
							<template v-slot="scope">
								<div class="d-s-c">
									{{ scope.row.category_name }}
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="价格" width="650">


							<template v-slot="scope">
								<el-button type="primary" size="small"
									@click="addPrice(scope.$index,scope.row.category_id)">
									添加价格
								</el-button>


								<el-button type="primary" size="small" v-if="scope.$index != 0"
									@click="copyPrice(scope.$index,scope.row.category_id)">
									复制上一个参数属性
								</el-button>

								<el-table :data="scope.row.hproduct_to_attr_price" border size="mini"
									style="width: 100%;margin-top: 20px;">
									<el-table-column prop="price" label="价格" width="120">
										<template v-slot="scope1">
											<el-input v-model="scope1.row.price" placeholder="请输入价格" type="number"
												min="0" step="0.01">

											</el-input>
										</template>
									</el-table-column>

									<el-table-column label="快捷选择" width="100">
										<template v-slot="scope1">
											<div style="display: flex; align-items: center;">
												<el-select
													@change="e => selectM(e, scope1.$index, scope.row.category_id)"
													placeholder="请选择" style="width: 70px; margin-left: 5px;">
													<el-option label="加算法" value="加算法"></el-option>
													<el-option label="乘算法" value="乘算法"></el-option>
													<el-option label="30厘米以下" value="30厘米以下"></el-option>
													<el-option label="30厘米以上" value="30厘米以上"></el-option>
													<el-option label="1厘米~30厘米" value="1厘米~30厘米"></el-option>

												</el-select>

												<!-- 添加备注图标 -->
												<el-tooltip content="查看备注" placement="top">
													<el-button type="text" @click="showRemark(scope1.$index, scope.row)"
														icon="el-icon-info" style="margin-left: 5px;"></el-button>
												</el-tooltip>
											</div>
										</template>
									</el-table-column>

									<!-- 备注弹窗 -->
									<el-dialog title="备注信息" :visible.sync="remarkDialogVisible" width="30%"
										:append-to-body="true">
										<div style="margin-top: 5px;"><span
												style="font-weight: 500;">加算法</span>：标品、基础定制、面积定制、周长定制均有效；跟字体长宽无关，单独在单价或者计算价格上加这个价格；
										</div>
										<div style="margin-top: 5px;"><span
												style="font-weight: 500;">乘算法</span>：面积定制有效；跟字体长宽有关，可按平方（200元/平方）或厘米（0.5元）进行计算；
										</div>
										<div style="margin-top: 5px;"><span
												style="font-weight: 500;">和算法</span>：是指在基础定制中，
											如果选择【大于/小于】区间一和区间二同时小于最大边或者大于最大边；
											如果不选择【大于/小于】，则换成区间，最大边大于等于区间一，小于区间二,选择这个区间的价格进行计算</div>

										<div style="margin-top: 10px;"><span style="font-weight: 500;">标品</span>：支持加算法
										</div>
										<div style="margin-top: 10px;"><span
												style="font-weight: 500;">周长定制</span>：周长定制只支持加算法；</div>
										<div style="margin-top: 5px;"><span
												style="font-weight: 500;">基础定制</span>：支持加算法、乘算法，和算法</div>
										<span slot="footer" class="dialog-footer">
											<el-button @click="remarkDialogVisible = false">关闭</el-button>
										</span>
									</el-dialog>

									<el-table-column label="尺寸范围" width="190">
										<template v-slot="scope1">
											<div class="size-range-container">
												<el-input v-model="scope1.row.min_size" placeholder="最小" type="number"
													min="0" style="width: 80px;" controls-position="right"></el-input>

												<el-select v-model="scope1.row.plus" placeholder="计算"
													style="width: 70px; margin-left: 5px;">
													<el-option label="加" value="加"></el-option>
													<el-option label="和" value="和"></el-option>
													<el-option label="乘" value="乘"></el-option>
												</el-select>
												<el-input v-model="scope1.row.max_size" placeholder="最大" type="number"
													min="0" style="width: 80px;" controls-position="right"></el-input>


												<el-select v-model="scope1.row.unit" placeholder="单位"
													style="width: 70px; margin-left: 5px;">
													<el-option label="mm" value="mm"></el-option>
													<el-option label="cm" value="cm"></el-option>
													<el-option label="m" value="m"></el-option>
												</el-select>


												<el-select v-model="scope1.row.plusf" placeholder="单位"
													style="width: 70px; margin-left: 5px;">
													<el-option label="不选择" value="不选择"></el-option>
													<el-option label="大于" value="大于"></el-option>
													<el-option label="小于" value="小于"></el-option>
												</el-select>

												<el-select v-model="scope1.row.unitf" placeholder="单位"
													style="width: 70px; margin-left: 5px;">
													<el-option label="不选择" value="不选择"></el-option>
													<el-option label="毫米" value="毫米"></el-option>
													<el-option label="厘米" value="厘米"></el-option>
													<el-option label="平方" value="平方"></el-option>
												</el-select>


											</div>
										</template>
									</el-table-column>

									<el-table-column prop="price" label="是否单独计算">
										<template v-slot="scope1">
											<el-switch v-model="scope1.row.is_jisuan" :active-value="1"
												:inactive-value="0" active-text="是" inactive-text="否"></el-switch>
										</template>
									</el-table-column>


									<el-table-column prop="price" label="备注">
										<template v-slot="scope1">
											<span>{{ getSizeDescription(scope1.row) }}</span>
										</template>
									</el-table-column>

									<el-table-column prop="price" label="操作">
										<template v-slot="scope1">
											<a @click="delprice(scope.$index,scope1.$index,scope.row.category_id)"
												style="color: blue;">删除</a>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>

						<el-table-column label="默认选中" width="70">
							<template v-slot="scope">
								<el-checkbox v-model="scope.row.is_default" :disabled="scope.row.is_default_disabled"
									@change="(val) => handleDefaultChange(val, scope.row, scope.$index)"></el-checkbox>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="操作" width="80">
							<template v-slot="scope">
								<div style="color: blue;cursor: pointer;" @click="delPara(scope.$index)">
									删除
								</div>
							</template>
						</el-table-column>
					</el-table>

				</el-form-item>
				<!-- 供应商选择 -->
				<!-- <el-form-item label="供应商" prop="supply_id">
  <el-select
    v-model="form.supply_id"
    @change="handleSupplierChange"
    filterable
    class="max-w460"
    placeholder="请选择供应商"
  >
    <el-option
      v-for="item in supply"
      :key="item.supply_id"
      :label="item.name || `供应商${item.supply_id}`"
      :value="item.supply_id"
    >
      <span>{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ item.supply_id }}</span>
    </el-option>
  </el-select>
</el-form-item> -->

				<el-form-item label="供应商">

					<el-table :data="form.supplyArray" border size="mini" style="width: 100%;margin-top: 20px;">

						<el-table-column prop="name" label="排序">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input style="width: 150px;" v-model="scope.row.sort"
										placeholder="请输入排序"></el-input>
								</div>
							</template>
						</el-table-column>


						<el-table-column prop="name" label="供应商" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									{{ scope.row.name }}
								</div>
							</template>
						</el-table-column>



						<el-table-column prop="name" label="1-30cm以内价格" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input v-model="scope.row.price"></el-input>

								</div>
							</template>
						</el-table-column>



						<el-table-column prop="name" label="30cm以上价格" width="100">
							<template v-slot="scope">
								<div class="d-s-c">
									<el-input v-model="scope.row.price_second"></el-input>

								</div>
							</template>
						</el-table-column>

						<el-table-column prop="name" label="操作" width="100">
							<template v-slot="scope">
								<div style="color: blue;" @click="delStore(scope.$index)">删除</div>

							</template>
						</el-table-column>
					</el-table>
				</el-form-item>


				<el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序"
						class="max-w460"></el-input></el-form-item>
				<!--提交-->
				<div class="common-button-wrapper">
					<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
					<el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
				</div>
			</el-form>
			<!--商品图片组件-->
			<Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
				@returnImgs="returnProductImgsFunc">上传图片
			</Upload>
			<!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
		</div>
	</el-dialog>

</template>

<script>
	import HproductApi from '@/api/hproduct.js';
	import Upload from '@/components/file/Upload';
	import Categoryas from "@/components/categorya/index.vue";
	import draggable from "vuedraggable";
	import Uediter from '@/components/UE.vue';
	import {
		error
	} from 'shelljs';
	import StatisticsApi from '@/api/statistics.js';
	import PostageApi from '@/api/postage.js';
	export default {
		components: {
			/*图片上传*/
			Upload: Upload,
			Categoryas,
			draggable,
			Uediter
		},
		data() {
			return {
				supply: [],
				postage: [],
				/*是否上传图片*/
				isupload: false,
				isImg: false,
				/*富文本配置*/
				ueditor: {
					text: '',
					config: {
						initialFrameWidth: 400,
						initialFrameHeight: 500
					}
				},
				categories: [],
				activeCategory: '',
				paramOverlayVisible: false,
				selectedCategories: [],
				selectedParams: [],
				filteredParams: [],
				preservedSelections: {},
				/*form表单数据*/
				form: {
					video_url: "",
					showStandardUpload:0,
					supply_id: [],
					category_id: 0,
					name: "",
					image: [],
					postages: [],
					bannar: [],
					supply_id: [],
					supplyArray: [],
					price: 0,
					type: [],
					tip: "",
					fview: 0,
					parameters: [],
					limitedSize: "",
					model: {
						grade_model: 1,
						is_alone_grade: 1,

					},
					is_standard: 0,

					hproducttoattrs: [],
					hproducttosubcategories: [],
					supplyArray: [],
				},
				loading: false,
				/*验证规则*/
				rules: {
					name: [{
						required: true,
						message: '请输入产品名称',
						trigger: 'blur'
					}]
				},
				issupply: false,
				supplyInfo: null,
				dialogVisible: false,
				iscategorya: false,
				excludeIds: [],
				isProductUpload: false,
				code: "album",
				type: [],
				catgory: [],
				parameterList: [], //参数列表
				isuse: 0,
			};
		},
		computed: {
			// 根据当前选中分类过滤出的产品列表
			filteredProducts() {
				if (!this.activeCategory) return [];
				return this.form.hproducttoattrs.filter(
					item => item.category_name === this.activeCategory
				);
			},

			selectedPostageNames() {
				if (!this.form.postages || !this.postage) return '暂无';
				return this.form.postages
					.map(id => {
						const item = this.postage.find(p => String(p.postage_id) === String(id));
						return item ? item.name : null;
					})
					.filter(Boolean)
					.join('、') || '暂无';
			}
		},
		created() {
			let supply = sessionStorage.getItem("supply") ? JSON.parse(sessionStorage.getItem("supply")) : null;
			if (supply && supply.supply_id) {
				this.issupply = true;
				this.supplyInfo = supply;
			}
			var self = this;
			self.getInas({}, function(res) {
				self.isuse = res
			})

			this.dialogVisible = this.open_add;
			this.getSetting();
			this.getPostage();
			this.getData();
			this.getSupplys();
		},
		props: ["open_add"],
		methods: {
			// 显示备注弹窗
			showRemark(index, row) {

				this.remarkDialogVisible = true;
			},
			getPostage() {
				PostageApi.list().then(data => {
					this.postage = data.data.list.data;
				}).catch(error => {
					console.error('获取邮费失败:', error);
				});
			},
			getSizeDescription(row) {
				const min = parseFloat(row.min_size) || 0;
				const max = parseFloat(row.max_size) || 0;
				const unit = row.unit || 'cm';
				const plus = row.plus; // "加" 或 "和"
				const plusf = row.plusf; // "大于" 或 "小于"
				const unitf = row.unitf; // "公分" 或 "平方"

				// 构建显示单位
				const displayUnit = unitf === "厘米" ? "厘米" : (unitf === "平方" ? "平方" : (unitf === "毫米" ? "毫米" : unit));

				// 情况1: 长加宽小于X公分 (min=0, max=X, plus="加", plusf="小于")
				if (min === 0 && max > 0 && plus === "加" && plusf === "小于") {
					return `长加宽小于${max}按${displayUnit}算`;
				}


				// 情况3: 长和宽小于X公分 (min=0, max=X, plus="和", plusf="小于")
				if (min === 0 && max > 0 && plus === "和" && plusf === "小于") {
					return `长和宽小于${max}按${displayUnit}算`;
				}


				// 情况3: 长和宽小于X公分 (min=0, max=X, plus="和", plusf="小于")
				if (min === 0 && max > 0 && plus === "和" && plusf === "大于") {
					return `长和宽大于${max}按${displayUnit}算`;
				}

				// 情况2: 长加宽大于X公分 (min=0, max=X, plus="加", plusf="大于")
				if (min === 0 && max > 0 && plus === "加" && plusf === "大于") {
					return `长加宽大于${max}按${displayUnit}算`;
				}



				if (min === 0 && max == 0 && plus === "乘") {
					return `长乘宽按${displayUnit}算`;
				}


				// 其他常规情况
				if (min > 0 && max > 0) {
					if (plus === "加") {
						return `${min}${displayUnit}加${max}${displayUnit}`;
					} else {
						return `${min}${displayUnit}~${max}${displayUnit}`;
					}
				} else if (min > 0) {
					return `${min}${displayUnit}以上`;
				} else if (max > 0) {
					return `${max}${displayUnit}以下`;
				} else {
					return '未设置尺寸范围';
				}
			},
			getSupplys() {
				let self = this;
				StatisticsApi.getSupplya({}, true)
					.then(data => {
						if (data.code === 1 && data.data) {
							self.supply = Array.isArray(data.data) ? data.data : [data.data];

							// 默认选择第一条供应商
							if (self.supply.length > 0 && self.supply[0].supply_id != 0) {
								self.form.supply_id = self.supply[0].supply_id;
								self.$set(self.form, 'supply_id', self.supply[0].supply_id);
								self.storeChange(self.supply[0]); // 自动添加到表格
							}
						}
					})
					.catch(error => {
						console.error('获取供应商数据异常:', error);
					});
			},

			handleDefaultChange(val, row, index) {
				if (val) {
					// 取消同一类别下其他参数的默认选中状态
					this.form.hproducttoattrs.forEach((item, i) => {
						if (i !== index && item.category_id === row.category_id) {
							this.$set(item, 'is_default', false);
							this.$set(item, 'is_default_disabled', false);
						}
					});
				}

				// 更新当前行的默认状态
				this.$set(row, 'is_default', val);

				// 更新同类别其他参数的禁用状态
				this.updateDefaultDisabledStates();
			},
			closeParamDialog() {
				this.paramOverlayVisible = false;
				this.selectedParams = [];
				this.filteredParams = [];
				this.selectedCategories = [];
			},
			delprice(index, index1, id) {
				let self = this
				var indexx = index;
				var hproducttoattrs = self.form.hproducttoattrs;
				for (var i = 0; i < hproducttoattrs.length; i++) {
					if (hproducttoattrs[i].category_id == id) {
						indexx = i;
						break;
					}
				}

				var hproduct_to_attr_price = this.form.hproducttoattrs[indexx].hproduct_to_attr_price;

				hproduct_to_attr_price.splice(index1, 1)
				this.$set(this.form.hproducttoattrs[indexx], 'hproduct_to_attr_price', hproduct_to_attr_price);
				this.$forceUpdate()
			},
			// 删除参数
			delPara(index, id) {
				let self = this

				var indexx = index;
				console.log(indexx)

				var hproducttoattrs = self.form.hproducttoattrs;
				for (var i = 0; i < hproducttoattrs.length; i++) {
					if (hproducttoattrs[i].category_id == id) {
						indexx = i;
						break;
					}
				}


				hproducttoattrs.splice(indexx, 1)
				this.$set(this.form, 'hproducttoattrs', hproducttoattrs);
				this.$forceUpdate()

			},
			selectM(e, index, id) {
				var self = this;

				var indexx = index;
				console.log(indexx)

				var hproducttoattrs = self.form.hproducttoattrs;
				for (var i = 0; i < hproducttoattrs.length; i++) {
					if (hproducttoattrs[i].category_id == id) {
						indexx = i;
						break;
					}
				}

				var hproduct_to_attr_price = hproducttoattrs[indexx].hproduct_to_attr_price;
				console.log('hproduct_to_attr_price', hproduct_to_attr_price);

				if (e == '加算法') {
					hproduct_to_attr_price[index].min_size = 0;
					hproduct_to_attr_price[index].max_size = 0;
					hproduct_to_attr_price[index].plus = "加"; //加 和 乘
					hproduct_to_attr_price[index].unit = "cm"; //mm  cm  m
					hproduct_to_attr_price[index].plusf = "不选择"; //不选择 大于  小于
					hproduct_to_attr_price[index].unitf = "不选择"; //不选择 毫米 厘米 平方

				} else if (e == '乘算法') {
					hproduct_to_attr_price[index].min_size = 0;
					hproduct_to_attr_price[index].max_size = 0;
					hproduct_to_attr_price[index].plus = "乘"; //加 和 乘
					hproduct_to_attr_price[index].unit = "cm"; //mm  cm  m
					hproduct_to_attr_price[index].plusf = "不选择"; //不选择 大于  小于
					hproduct_to_attr_price[index].unitf = "厘米"; //不选择 毫米 厘米 平方

				} else if (e == '30厘米以下') {
					hproduct_to_attr_price[index].min_size = 0;
					hproduct_to_attr_price[index].max_size = 30;
					hproduct_to_attr_price[index].plus = ""; //加 和 乘
					hproduct_to_attr_price[index].unit = "cm"; //mm  cm  m
					hproduct_to_attr_price[index].plusf = "不选择"; //不选择 大于  小于
					hproduct_to_attr_price[index].unitf = "不选择"; //不选择 毫米 厘米 平方

				} else if (e == '30厘米以上') {
					hproduct_to_attr_price[index].min_size = 30;
					hproduct_to_attr_price[index].max_size = 0;
					hproduct_to_attr_price[index].plus = ""; //加 和 乘
					hproduct_to_attr_price[index].unit = "cm"; //mm  cm  m
					hproduct_to_attr_price[index].plusf = "不选择"; //不选择 大于  小于
					hproduct_to_attr_price[index].unitf = "不选择"; //不选择 毫米 厘米 平方

				} else if (e == '1厘米~30厘米') {
					hproduct_to_attr_price[index].min_size = 1;
					hproduct_to_attr_price[index].max_size = 30;
					hproduct_to_attr_price[index].plus = "和"; //加 和 乘
					hproduct_to_attr_price[index].unit = "cm"; //mm  cm  m
					hproduct_to_attr_price[index].plusf = "不选择"; //不选择 大于  小于
					hproduct_to_attr_price[index].unitf = "不选择"; //不选择 毫米 厘米 平方
				}



				hproducttoattrs[indexx].hproduct_to_attr_price = JSON.parse(JSON.stringify(hproduct_to_attr_price));
				console.log('this.form', this.form);
				this.$set(this.form, 'hproducttoattrs', hproducttoattrs);
				this.$forceUpdate()

			},
			copy(index, id, arr) {
				let self = this

				var indexx = index;
				console.log(indexx)

				var hproducttoattrs = self.form.hproducttoattrs;
				for (var i = 0; i < hproducttoattrs.length; i++) {
					if (hproducttoattrs[i].category_id == id) {
						indexx = i;
						break;
					}
				}

				hproducttoattrs.push(arr)
				this.$set(this.form, 'hproducttoattrs', hproducttoattrs);
				this.$forceUpdate()

			},

			copyPrice(index, id) {
				// 找到目标索引（indexx）
				let indexx = index;
				for (let i = 0; i < this.form.hproducttoattrs.length; i++) {
					if (this.form.hproducttoattrs[i].category_id === id) {
						indexx = i;
						break;
					}
				}

				// 获取要复制的价格数组
				const sourcePrices = this.form.hproducttoattrs[index - 1].hproduct_to_attr_price;

				// 获取目标数组（确保是数组）
				let targetPrices = this.form.hproducttoattrs[indexx].hproduct_to_attr_price;
				if (!Array.isArray(targetPrices)) {
					targetPrices = [];
				}

				// 合并数组（注意concat返回新数组）
				targetPrices = targetPrices.concat(sourcePrices);

				// 更新数据（使用Vue.set确保响应式）
				this.$set(this.form.hproducttoattrs[indexx], 'hproduct_to_attr_price', targetPrices);

				// 通常不需要forceUpdate，$set已经足够
			},
			addPrice(index, id) {
				console.log('index', index)
				// 在需要加载的地方
				this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})
				console.log('this.form.hproducttoattrs', this.form.hproducttoattrs)
				var indexx = index;
				for (var i = 0; i < this.form.hproducttoattrs.length; i++) {
					if (this.form.hproducttoattrs[i].category_id == id) {
						indexx = i;
						break;
					}
				}

				var hproduct_to_attr_price = this.form.hproducttoattrs[indexx].hproduct_to_attr_price;

				console.log('this.form.hproducttoattrs[indexx]', this.form.hproducttoattrs[indexx])
				if (Array.isArray(hproduct_to_attr_price)) {
					hproduct_to_attr_price.push({
						price: 0,
						min_size: 0,
						max_size: 0,
						unit: 'cm',

					})
				} else {
					hproduct_to_attr_price = [];
					hproduct_to_attr_price.push({
						price: 0,
						min_size: 0,
						max_size: 0,
						unit: 'cm',

					})
				}
				console.log(' this.form.hproducttoattrs[indexx].hproduct_to_attr_price', hproduct_to_attr_price);

				this.$set(this.form.hproducttoattrs[indexx], 'hproduct_to_attr_price', hproduct_to_attr_price);
				this.$forceUpdate()
				// 获取数据后关闭
				this.$loading().close()
			},

			// 初始化分类列表
			initCategories() {
				// 从原始数据中提取所有不重复的分类
				const categorySet = new Set();
				this.form.hproducttoattrs.forEach(item => {
					if (item.category_name) {
						categorySet.add(item.category_name);
					}

				});

				this.categories = Array.from(categorySet).map(category => ({
					label: category,
					value: category
				}));

				// 默认选中第一个分类
				if (this.categories.length > 0) {
					this.activeCategory = this.categories[0].value;
				}
			},

			// 分类切换事件
			handleCategoryChangex(category) {
				this.activeCategory = category;
			},
			updateDefaultDisabledStates() {
				// 找出所有有默认选中参数的类别
				const defaultCategories = {};
				this.form.hproducttoattrs.forEach(item => {
					if (item.is_default) {
						defaultCategories[item.category_id] = true;
					}
				});

				// 更新禁用状态
				this.form.hproducttoattrs.forEach(item => {
					this.$set(item, 'is_default_disabled',
						defaultCategories[item.category_id] && !item.is_default
					);
				});
			},
			openParamDialog() {
				console.log("完整parameterList数据:", JSON.stringify(this.parameterList, null, 2));
				this.paramOverlayVisible = true;

				if (this.parameterList && this.parameterList.length > 0) {
					this.activeCategory = String(this.parameterList[0].category_id);
					this.handleCategoryChange(this.activeCategory);
				}
			},

			handleCategoryChange(selectedCategoryIds) {
				// Reset filtered params
				this.filteredParams = [];

				// Process each selected category
				selectedCategoryIds.forEach(catId => {
					const category = this.parameterList.find(c => String(c.category_id) === String(catId));
					console.log('category', category)
					if (category) {
						const categoryParams = (category.child || []).map(param => ({
							...param,
							category_name: category.name,
							tempSort: param.sort || 0,
							tempPrice: param.tempPrice || 0,
							tempPrice_second: param.tempPrice_second || 0
						}));

						this.filteredParams = [...this.filteredParams, ...categoryParams];
					}
				});

				// Preserve selections when changing categories
				this.selectedParams = this.selectedParams.filter(param =>
					this.filteredParams.some(fp => fp.id === param.id)
				);
			},

			handleSelectionChange(selection) {
				const prevSelected = this.selectedParams.filter(param =>
					!this.filteredParams.some(p => p.category_id === param.category_id)
				);

				// 合并新旧选择
				this.selectedParams = [...prevSelected, ...selection];
				console.log("当前已选参数selectedParams:", this.selectedParams);
			},
			saveSelectedParams() {
				if (!this.selectedParams || this.selectedParams.length === 0) {
					this.$message.warning("请至少选择一个参数");
					return;
				}

				// 创建合并后的参数数组（基于ID去重）
				const mergedParams = [
					...this.form.hproducttoattrs,
					...this.selectedParams
				].reduce((acc, current) => {
					// 检查是否已存在相同ID的参数
					const existingIndex = acc.findIndex(item => item.category_id === current.category_id);

					if (existingIndex === -1) {
						// 如果是新参数，直接添加
						acc.push(current);
					} else {
						// 如果已存在，则合并更新（保留现有参数的某些属性）
						acc[existingIndex] = {
							...acc[existingIndex], // 保留原参数属性
							...current, // 用新参数覆盖
							// 特别处理某些不想被覆盖的属性
							is_default: acc[existingIndex].is_default
						};
					}
					return acc;
				}, []);

				// 响应式更新数组
				this.$set(this.form, 'hproducttoattrs', mergedParams);

				console.log('合并后的参数:', mergedParams);
				this.closeParamDialog();
				this.initCategories();
				this.$message.success(`成功添加/更新 ${this.selectedParams.length} 个参数`);
			},

			//  选择供应商
			storeChange(e) {
				if (!e || !e.supply_id) return;

				// 初始化数组
				if (!Array.isArray(this.form.supplyArray)) {
					this.form.supplyArray = [];
				}
				if (!Array.isArray(this.form.supply_id)) {
					this.form.supply_id = [];
				}

				// 检查是否已存在
				const exists = this.form.supplyArray.some(item => item.supply_id == e.supply_id);

				if (!exists) {
					this.form.supply_id.push(e.supply_id);
					this.form.supplyArray.push({
						sort: e.sort || 50,
						price: this.form.price || 0,
						price_second: 0, // 添加默认值
						name: e.name,
						supply_id: e.supply_id
					});

					// 确保响应式更新
					this.$set(this.form, 'supplyArray', [...this.form.supplyArray]);
				}
			},
			delStore(index) {
				this.form.supplyArray.splice(index, 1)
			},
			// 选择一级参数
			parameterChange(e) {
				let that = this
				let par = e
				if (that.form.hproducttoattrs.length > 0) {
					that.form.hproducttoattrs.forEach((v, i) => {
						if (v.category_id != e.category_id) {
							that.form.hproducttoattrs.push(e)
							throw error("stop")
						}
					})
				} else {
					that.form.hproducttoattrs.push(e)
				}
			},



			// 获取参数列表
			getData() {
				let self = this;
				HproductApi.attrList({
						supply_id: " "
					}, true)
					.then(data => {
						console.log("data", data)
						if (data.code == 1) {
							self.parameterList = data.data.list
						}
						// self.loading = false;
						// self.tableData = data.data.list;
						// self.categoryModel.catList = self.tableData;
					})
					.catch(error => {
						self.loading = false;
					});
			},
			getSetting() {
				var self = this;
				self.getSetting_common({
					"item": 'hproduct',
					"condi": ['catgory', 'hproduct_subcategory']
				}, function(data) {
					self.type = data.obj.hproduct_subcategory
					self.catgory = data.obj.catgory;
				})
			},
			delType(index) {
				this.form.hproducttosubcategories.splice(index, 1)
			},

			typeChange(e) {
				var ind = 0;
				for (var i = 0; i < this.form.hproducttosubcategories.length; i++) {
					if (this.form.hproducttosubcategories[i].hproduct_subcategory_id == e.hproduct_subcategory_id) {
						ind++;
					}
				}
				if (ind <= 0) {

					e.max_width = 1000;
					e.max_height = 1000;
					e.max_thickness = 1000;
					this.form.hproducttosubcategories.push(e);
				}

			},
			chooseCategory() {
				this.iscategorya = true;
			},
			/*上传*/
			openUpload(e) {
				this.isupload = true;
			},


			/*关闭弹窗*/
			dialogFormVisible(result) {
				this.$emit("close", {
					openDialog: false,
					"type": ""
				});
			},
			cancelFunc() { //取消
				this.dialogFormVisible("error")
			},

			onSubmit() {
				let self = this;

				let form = JSON.parse(JSON.stringify(self.form));
				console.log("form", form)
				form.subcategory_id = []
				form.attr_id = []
				form.type.forEach((v, i) => {
					let tep = {}
					tep.hproduct_subcategory_id = v.hproduct_subcategory_id
					tep.sort = v.sort
					form.subcategory_id.push(tep)
				})
				if (!Array.isArray(form.postages)) {
					form.postages = form.postages ? [form.postages] : [];
				}
				form.parameters.forEach((v, i) => {
					let tep = {}
					tep.category_id = v.category_id
					tep.sort = v.sort
					form.attr_id.push(tep)
				})
				if (this.issupply) {
					form.supplyArray = [];
					form.supply_id = [];
					form.supply_id.push(this.supplyInfo.supply_id);
					form.supplyArray.push({
						supply_id: this.supplyInfo.supply_id,
						sort: this.supplyInfo.sort,
						price: this.form.price,
						name: this.supplyInfo.name
					});
				}

				form.supply_id = JSON.stringify(form.supply_id);
				form.supplyArray = JSON.stringify(form.supplyArray);
				self.$refs.form.validate(valid => {
					if (valid) {
						self.loading = true;
						HproductApi.add(form, true)
							.then(data => {
								self.loading = false;
								self.$message({
									message: data.msg,
									type: 'success'
								});
								self.dialogFormVisible("error")
							})
							.catch(error => {
								self.loading = false;
							});
					}
				});
			},

			/*取消添加，返回任务列表*/
			cancelFunc() {
				this.$emit("close", {
					openDialog: false,
					"type": ""
				});
			},
			/*打开上传图片*/
			openProductUpload: function(code) {
				// this.isProductUpload = true;
				this.isProductUpload = true;
				this.code = code
			},

			/*上传商品图片*/
			returnProductImgsFunc(e) {
				if (this.code == 'album') {
					if (e != null) {
						let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
						let prevent = false;
						console.log(typeof imgExpt);
						e.forEach((element) => {
							let data_array = element.file_path.split(".");
							let ext = data_array[data_array.length - 1];
							imgExpt.forEach((e) => {
								if (e === ext) {
									prevent = true
									return false
								}
							});
						});

						if (!prevent) {
							this.$message.error("图片类型有误,请选择正确的图片格式");
							return false;
						}
						this.form.image = e[0].file_path;
						this.$set(this.form, "image", this.form.image);
					}
				} else if (this.code == 'videourl') {
					if (e != null) {
						let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif", "mp4"];
						let prevent = false;
						console.log(typeof imgExpt);
						console.log('e', e);
						e.forEach((element) => {
							let data_array = element.file_path.split(".");
							let ext = data_array[data_array.length - 1];
							imgExpt.forEach((e) => {
								if (e === ext) {
									prevent = true
									return false

								}
							});
						});

						// if (!prevent) {
						//   this.$message.error("图片类型有误,请选择正确的图片格式");
						//   return false;
						// }

					      this.form.video_url = e[0].file_path;


					}
				} else {
					if (e != null) {
						let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
						let prevent = false;
						console.log(typeof imgExpt);
						e.forEach((element) => {
							let data_array = element.file_path.split(".");
							let ext = data_array[data_array.length - 1];
							imgExpt.forEach((e) => {
								if (e === ext) {
									prevent = true
									return false
								}
							});
						});

						if (!prevent) {
							this.$message.error("图片类型有误,请选择正确的图片格式");
							return false;
						}

						let imgs = this.form.bannar.concat(e);
						this.$set(this.form, "bannar", imgs);
					}
				}

				this.isProductUpload = false;
			},

			/*删除商品图片*/
			deleteImg(index, code) {
				if (code == 'album') {
					this.form.image = ""
				} else if (code == 'bannar') {
					this.form.bannar.splice(index, 1);
				}

			},

		}
	};
</script>

<style>
	/* 在style部分添加 */
	.remark-btn {
		color: #409EFF;
		font-size: 16px;
		padding: 0;
		margin-left: 8px;
	}

	.remark-btn:hover {
		color: #66b1ff;
	}

	.edit_container {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ql-editor {
		height: 400px;
	}



	.draggable-list {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.param-selector-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 2000;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.param-selector-container {
		width: 80%;
		height: 80%;
		background: white;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
	}

	.param-selector-header {
		padding: 15px 20px;
		border-bottom: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.param-selector-body {
		flex: 1;
		overflow: hidden;
		display: flex;
	}

	.param-selector-footer {
		padding: 15px 20px;
		border-top: 1px solid #eee;
		text-align: right;
	}

	.draggable-list .wrapper>span {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.draggable-list .item {
		position: relative;
		width: 110px;
		height: 110px;
		margin-top: 10px;
		margin-right: 10px;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #dddddd;
	}

	.draggable-list .delete-btn {
		position: absolute;
		top: 0;
		right: 0;
		width: 16px;
		height: 16px;
		background: red;
		line-height: 16px;
		font-size: 16px;
		color: #ffffff;
		display: none;
	}

	.draggable-list .item:hover .delete-btn {
		display: block;
	}

	.draggable-list .item img {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		max-height: 100%;
		max-width: 100%;
	}

	.draggable-list .img-select {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px dashed #dddddd;
		font-size: 30px;
	}

	.draggable-list .img-select i {
		color: #409eff;
	}
</style>



// WEBPACK FOOTER //
// src/views/plus/hproduct/index/part/add.vue